import React from 'react';
import MapIcon from '@mui/icons-material/Map';
import { IconButton, Button, Grid } from '@mui/material';

import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import LeafletMapFilter from '../LeafletMapFilter';
import makeStyles from '@mui/styles/makeStyles';
import { blue } from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.paper,
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	button: {
		flex: 1,
		color: blue[900],
		margin: 10,
		justifyContent: 'center',
		alignSelf: 'center',

		'&.MuiButton-root.active': {
			color: '#FF0000',
			borderColor: '#FF0000'
		}
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	},
	filterBtn: {
		marginTop: '8px',
		textTransform: 'none',
		letterSpacing: 'normal',
		fontWeight: 'normal'
	}
}));

const DialogTitle = ({ children, onClose, ...other }) => {
	const classes = useStyles();
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
					size="large"
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
};

export default function MapSearch({
	handleSearch,
	refreshListings,
	rectFilter,
	circleFilter,
	open,
	listings,
	setRestoredFilters,
	restoredFilters,
	setRectFilter,
	setCircleFilter,
	clearMapFilter,
	handleMapSearchSubmit,
	handleClose,
	handleOpen,
	drawingControlEnabled,
	setDrawingControlEnabled
}) {
	const classes = useStyles();

	const filtersLength = () => {
		let count = 0;
		if (rectFilter && Object.keys(rectFilter).length > 0) count++;
		if (circleFilter && Object.keys(circleFilter).length > 0) count++;
		return count;
	};

	return (
		<React.Fragment>
			<Grid item>
				<Button
					variant="outlined"
					onClick={handleOpen}
					startIcon={<MapIcon />}
					id="mapFilter"
					className={classes.filterBtn}
					style={{
						color:
							(rectFilter || circleFilter) && filtersLength() ? '#02838D' : '#004F2B',
						borderColor:
							(rectFilter || circleFilter) && filtersLength() ? '#02838D' : '#004F2B'
					}}
				>
					Map{' '}
					{(rectFilter || circleFilter) && filtersLength() ? `(${filtersLength()})` : ''}
				</Button>
			</Grid>
			<Dialog
				maxWidth={'lg'}
				fullWidth
				open={open}
				onClose={handleClose}
				aria-labelledby="search"
			>
				<DialogTitle id="map-search" onClose={handleClose}>
					{'Filter By Map Area'}
				</DialogTitle>
				<DialogContent dividers>
					<LeafletMapFilter
						circleFilter={circleFilter}
						rectFilter={rectFilter}
						onRectFilterUpdate={setRectFilter}
						onCircleFilterUpdate={setCircleFilter}
						restoredFilters={restoredFilters}
						setRestoredFilters={setRestoredFilters}
						listings={listings}
						drawingControlEnabled={drawingControlEnabled}
						setDrawingControlEnabled={setDrawingControlEnabled}
					/>
					<Grid xs={12} container spacing={1}>
						<Grid xs={6} item>
							<Button
								variant="contained"
								color="secondary"
								fullWidth
								onClick={clearMapFilter}
								disabled={rectFilter === null && circleFilter === null}
								style={{ marginTop: '8px' }}
							>
								Clear
							</Button>
						</Grid>
						<Grid xs={6} item>
							<Button
								type="submit"
								variant="contained"
								color="primary"
								fullWidth
								onClick={handleMapSearchSubmit}
								disabled={rectFilter === null && circleFilter === null}
								style={{ marginTop: '8px' }}
							>
								Save
							</Button>
						</Grid>
					</Grid>
				</DialogContent>
			</Dialog>
		</React.Fragment>
	);
}
